module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "navbar border-sgs"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [(_vm.isLogged) ? _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "id": "open"
    },
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_c('span', {
    staticClass: "icon-bar",
    staticStyle: {
      "background": "black"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar",
    staticStyle: {
      "background": "black"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar",
    staticStyle: {
      "background": "black"
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', [_c('Brand')], 1)]), _vm._v(" "), (_vm.isLogged) ? _c('div', {
    staticClass: "collapse navbar-collapse",
    class: _vm.meuCollapse,
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBusinessLine),
      expression: "showBusinessLine"
    }],
    attrs: {
      "to": {
        name: 'BusinessAreaList'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("businessLine")))])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContracts),
      expression: "showContracts"
    }],
    attrs: {
      "to": {
        name: 'SystemsList'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("contracts")))])])], 1), _vm._v(" "), (_vm.contractMenuShow) ? _c('subMenuResponsive', {
    attrs: {
      "meuCollapse": _vm.meuCollapse
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.isLogged) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doLogout.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("logout")))])]) : _vm._e()])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8055b236!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/header/MenuResponsive.vue
// module id = 943
// module chunks = 2